import type { Environment } from "../../types";

export const GLOBAL_MENU_URLS: Record<Environment, string> = {
  dev: "https://stg-contents.crosstoken.io/frontend/common/app-launcher/app-launcher-v2.json",
  stage: "https://stg-contents.crosstoken.io/frontend/common/app-launcher/app-launcher-v2.json",
  production: "https://contents.crosstoken.io/frontend/common/app-launcher/app-launcher-v2.json",
};
